import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, of, switchMap, tap } from 'rxjs';

import { EffectsBase } from '@ps/core-data-access';
import { ToastService } from '@ps/core-overlay';

import { SupplierService } from '../services/supplier.service';
import { SupplierActions } from './supplier.actions';

@Injectable()
export class SupplierEffects extends EffectsBase {
  private readonly _actions$ = inject(Actions);
  private readonly _service = inject(SupplierService);

  private readonly _toastService = inject(ToastService);

  public readonly loadSuppliers$ = createEffect(() => {
    return this._actions$.pipe(
      ofType(SupplierActions.loadSuppliers),
      switchMap(({ buyerId }) =>
        this._service.getAll(buyerId).pipe(
          map((suppliers) =>
            SupplierActions.loadSuppliersSuccess({ suppliers }),
          ),
          this.psCatchError(
            (error) =>
              of(
                SupplierActions.loadSuppliersFailure({
                  error: error.message,
                }),
              ),
            {
              notify: true,
              customMessage: 'Failed to load suppliers. Please try again.',
            },
          ),
        ),
      ),
    );
  });

  public readonly saveSupplierAccess$ = createEffect(() => {
    return this._actions$.pipe(
      ofType(SupplierActions.saveSupplierAccess),
      switchMap(({ buyerId, suppliers }) =>
        this._service.saveAccess({ buyerId, suppliers }).pipe(
          tap(() =>
            this._toastService.success(
              'Success! Supplier status has been saved',
            ),
          ),
          map(() => SupplierActions.saveSupplierAccessSuccess()),
          this.psCatchError(
            (error) =>
              of(
                SupplierActions.saveSupplierAccessFailure({
                  error: error.message,
                }),
              ),
            {
              notify: true,
              customMessage:
                'Failed to save supplier access. Please try again.',
            },
          ),
        ),
      ),
    );
  });
}
